/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from 'components/Code';
import Table, {Row, Column} from 'components/Table';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    ol: "ol",
    li: "li",
    pre: "pre",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "createGlobalStyle"
      }), " | v4 | web-only"]
    }), "\n", _jsxs(_components.p, {
      children: ["A helper function to generate a special ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " that handles global styles. Normally, styled components are automatically scoped to a local CSS class and therefore isolated from other components. In the case of ", _jsx(_components.code, {
        children: "createGlobalStyle"
      }), ", this limitation is removed and things like CSS resets or base stylesheets can be applied."]
    }), "\n", _jsx(Table, {
      head: ['Arguments', 'Description'],
      children: _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsxs(_components.ol, {
            children: ["\n", _jsxs(_components.li, {
              children: ["\n", _jsx(Code, {
                children: "TaggedTemplateLiteral"
              }), "\n"]
            }), "\n"]
          })
        }), _jsx(Column, {
          children: "A tagged template literal with your CSS and interpolations."
        })]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Returns a ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " that does not accept children. Place it at the top of your React tree and the global styles will be injected when the component is \"rendered\"."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { createGlobalStyle } from 'styled-components'\n\nconst GlobalStyle = createGlobalStyle<{ $whiteColor?: boolean; }>`\n  body {\n    color: ${props => (props.$whiteColor ? 'white' : 'black')};\n  }\n`\n\n// later in your app\n\n<React.Fragment>\n  <GlobalStyle $whiteColor />\n  <Navigation /> {/* example of other top-level stuff */}\n</React.Fragment>\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Since the ", _jsx(_components.code, {
        children: "GlobalStyle"
      }), " component is a ", _jsx(_components.code, {
        children: "StyledComponent"
      }), ", that means it also has access to theming from the ", _jsxs(_components.a, {
        href: "/docs/api#themeprovider",
        children: [_jsx(_components.code, {
          children: "<ThemeProvider>"
        }), " component"]
      }), " if provided."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { createGlobalStyle, ThemeProvider } from 'styled-components'\n\nconst GlobalStyle = createGlobalStyle<{ $whiteColor?: boolean; }>`\n  body {\n    color: ${props => (props.$whiteColor ? 'white' : 'black')};\n    font-family: ${props => props.theme.fontFamily};\n  }\n`\n\n// later in your app\n\n<ThemeProvider theme={{ fontFamily: 'Helvetica Neue' }}>\n  <React.Fragment>\n    <Navigation /> {/* example of other top-level stuff */}\n    <GlobalStyle $whiteColor />\n  </React.Fragment>\n</ThemeProvider>\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
